import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { ReactNode } from 'react'

interface GovUKGridProps {
  children: ReactNode
  className?: string
}

type GovUKGridColumnWidth =
  | 'full'
  | 'one-half'
  | 'one-third'
  | 'two-thirds'
  | 'one-quarter'
  | 'three-quarters'

interface GovUKGridColumnProps {
  children: ReactNode
  width?: GovUKGridColumnWidth
  className?: string
}

export function GovUKGrid({ children, className }: GovUKGridProps) {
  const classes = ['govuk-grid-row', className].filter(Boolean).join(' ')

  return <div className={classes}>{children}</div>
}

export function GovUKGridColumn({
  children,
  width = 'full',
  className,
}: GovUKGridColumnProps) {
  const classes = [`govuk-grid-column-${width}`, className]
    .filter(Boolean)
    .join(' ')

  return <div className={classes}>{children}</div>
}
